import { render, staticRenderFns } from "./ThemeSimpleTable.vue?vue&type=template&id=645a03fe&scoped=true"
import script from "./ThemeSimpleTable.vue?vue&type=script&lang=js"
export * from "./ThemeSimpleTable.vue?vue&type=script&lang=js"
import style0 from "./ThemeSimpleTable.vue?vue&type=style&index=0&id=645a03fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a03fe",
  null
  
)

export default component.exports